import { EmptyDataMessage } from '@/common/components/EmptyDataMessage'
import { Pagination } from '@/common/components/Table/pagination'
import { twMerge } from 'tailwind-merge'
import { RewardItemsGridItem } from '../RewardItemsGridItem'
import { RewardItemData } from '@/common/types/rewardItems'
import { RewardItemsGridLoading } from '../RewardItemsGridLoading'

interface RewardItemsGridTableProps {
  className?: string
  rewardItems: RewardItemData[]
  page: number
  totalPages: number
  totalCount?: number
  setPage?: React.Dispatch<React.SetStateAction<number | undefined>>
  isLoadingData: boolean
  hasSelection?: boolean
}

export const RewardItemsGridTable = ({
  className,
  rewardItems,
  page,
  totalPages,
  totalCount,
  setPage,
  isLoadingData,
}: RewardItemsGridTableProps) => {
  return isLoadingData || !!rewardItems.length ? (
    <div className='flex-1'>
      <div        
        data-testid="tmais_reward_items_grid"
        className={twMerge(
          'grid grid-cols-[repeat(auto-fill,minmax(216px,1fr))] gap-4 overflow-y-auto max-h-[calc(100vh-256px)] pb-4',
          className,
        )}
      >
        {isLoadingData ? (
          Array(20)
            .fill(0)
            .map((_, index) => <RewardItemsGridLoading key={index} />)
        ) : (
          <>
            {rewardItems.map((rewardItem) => (
              <RewardItemsGridItem key={rewardItem.id} rewardItem={rewardItem} />
            ))}
          </>
        )}
      </div>
      <div
        className={twMerge(
          'w-full px-4 py-2 bg-black-300 rounded-lg flex justify-between items-center sticky bottom-0',
          typeof totalCount === 'undefined' && 'justify-end',
        )}
      >
        {typeof totalCount !== 'undefined' ? (
          <p className="text-xs italic font-light">
            Mostrando {rewardItems.length} resultados de {totalCount}
          </p>
        ) : null}
        {setPage && <Pagination currentPage={Number(page)} setPage={setPage} totalPages={totalPages} />}
      </div>
    </div>
  ) : (
    <EmptyDataMessage className={className} />
  )
}
